import cx from 'clsx';
import React, { FunctionComponent, SVGProps } from 'react';
import styles from './Button.module.scss';
import typographyStyles from 'styles/global/typography.module.scss';
import displayStyles from 'styles/global/display.module.scss';

interface OwnProps {
  size?: 'regular' | 'small';
  color?: 'accent';
  icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
}

type ButtonAsProps = {
  as?: 'button';
} & JSX.IntrinsicElements['button'];

type AnchorAsProps = {
  as: 'a';
} & JSX.IntrinsicElements['a'];

type ButtonProps = (ButtonAsProps & OwnProps) | (AnchorAsProps & OwnProps);

const Button: FunctionComponent<ButtonProps> = props => {
  const { as = 'button', color = 'accent', className, icon, children, size = 'regular', ...rest } = props;

  const buttonClassName = cx({
    [displayStyles.centerInlineBoth]: true,
    [typographyStyles.new_neue_16]: size === 'regular',
    [styles.button]: true,
    [styles[size]]: true,
    [styles[color]]: true,
    [styles.icon]: !children && icon,
    ...(className && { [className]: true }),
  });

  const Tag = as;
  const Icon = icon;

  return (
    <Tag className={buttonClassName} {...(rest as any)}>
      {Icon && <Icon />}
      {children}
    </Tag>
  );
};

export default Button;
